import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Loading from '../Loading';


const ModalNewChat = ({ clones }) => {

    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [filteredClones, setFilteredClones] = useState(clones?.data || []);

    useEffect(() => {
        if (search?.trim() === '' || search?.length == 0) {
            setFilteredClones(clones || []);
        } else {
            const filtered = clones?.filter(clone =>
                clone?.data?.name?.toLowerCase().includes(search?.toLowerCase())
            );
            setFilteredClones(filtered || []);
        }
    }, [search, clones]);

    return (
        <div className="modal fade" tabIndex="-1" id="newChat">
            <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content border-0">
                    <div className="modal-body p-4">
                        <h4 className="pb-2">Search by Name</h4>
                        <div className="form-group">
                            <div className="form-control-wrap">
                                <div className="form-control-icon start">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                    </svg>
                                </div>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    id="search"
                                    placeholder="Search clone"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        {filteredClones.length > 0 ? (
                            <div className="scrollable-list">
                                <Loading status={clones?.loading}>
                                    <ul className="tyn-media-list gap gap-2 pt-4">
                                        {filteredClones.map((clone, index) => (
                                            <li key={clone?.data?._id || index}>
                                                <button
                                                    className="clickable-item"
                                                >
                                                    <div className="tyn-media-group">
                                                        <div className="tyn-media">
                                                            <img src={clone?.data?.picture?.media || '/images/avatar/avatar-default.jpg'} alt={clone?.data?.name} />
                                                        </div>
                                                        <div className="tyn-media-col">
                                                            <h6 className="name text-capitalize" data-bs-dismiss="modal"
                                                            onClick={() => {navigate(`/chat/${clone?._id}`)}} >
                                                                {clone?.data?.name} {clone?.data?.surname}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </Loading>

                            </div>
                        ) : (
                            <p className='text-center mt-5' style={{ fontSize: "14px" }}>There's no clone yet.</p>
                        )}


                    </div>
                    <button className="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div >
    )
}

export default ModalNewChat